import dayjs from 'dayjs'

export default {
    props: {
        startMonth: { type: Number, required: false },
        startYear: { type: Number, required: false },
    },

    data: () => ({
        month: dayjs().get('month'),
        year: dayjs().get('year'),
        dateToday: dayjs().format('YYYY-MM-DD'),
    }),

    computed: {
        weekDays() {
            return Array(7)
                .fill(1)
                .map((day, index) =>
                    this.$t(
                        `common.days.${dayjs()
                            .day(index + 1)
                            .format('ddd')
                            .toLowerCase()}.short`,
                    ),
                )
        },

        monthDaysWithoutEndPadding() {
            const monthDaysObject = this.monthDaysObject()

            return [...monthDaysObject.startPadding, ...monthDaysObject.actualDaysWithDates]
        },

        monthDays() {
            const monthDaysObject = this.monthDaysObject()

            return [...monthDaysObject.startPadding, ...monthDaysObject.actualDays, ...monthDaysObject.endPadding]
        },

        dateLabel() {
            const date = dayjs().set('month', this.month).set('year', this.year)
            const month = this.$t(`common.months.${this.month}.long`)
            const year = date.format('YYYY')
            return `${month} ${year}`
        },
    },

    methods: {
        monthDaysObject() {
            const startOfCurrentMonth = dayjs.utc().year(this.year).month(this.month).startOf('month')
            const startPadding = Array((startOfCurrentMonth.day() || 7) - 1).fill(null)
            const actualDays = Array(startOfCurrentMonth.daysInMonth())
                .fill(1)
                .map((day, index) => index + 1)

            const actualDaysWithDates = Array(startOfCurrentMonth.daysInMonth())
                .fill(1)
                .map((day, index) => ({
                    day: index + 1,
                    date: dayjs()
                        .set('year', this.year)
                        .set('month', this.month)
                        .set('date', index + 1)
                        .startOf('day'),
                }))

            const endPadding =
                (startPadding.length + actualDays.length) % 7
                    ? Array(7 - ((startPadding.length + actualDays.length) % 7)).fill(null)
                    : []

            return {
                startPadding,
                actualDays,
                actualDaysWithDates,
                endPadding,
            }
        },

        loadCurrentMonth() {
            const date = dayjs.utc().set('month', this.month).set('year', this.year)

            this.emitDateChange(date)
        },

        goMonthBack() {
            const date = dayjs.utc().set('month', this.month).set('year', this.year).subtract(1, 'month')
            this.month = date.get('month')
            this.year = date.get('year')

            this.emitDateChange(date)
        },

        goMonthForward() {
            const date = dayjs.utc().set('month', this.month).set('year', this.year).add(1, 'month')
            this.month = date.get('month')
            this.year = date.get('year')

            this.emitDateChange(date)
        },

        emitDateChange(date) {
            this.emitEvent({
                name: 'date-change',
                payload: {
                    dateFrom: date.clone().startOf('month').format('YYYY-MM-DD'),
                    dateTo: date.clone().endOf('month').format('YYYY-MM-DD'),
                },
            })
        },

        isToday(day) {
            if (!day) {
                return false
            }
            return this.dateToday === this.getDate(day)
        },

        getDate(day) {
            return dayjs().set('year', this.year).set('month', this.month).set('date', day).format('YYYY-MM-DD')
        },
    },

    mounted() {
        if (this.startMonth) {
            this.month = this.startMonth - 1
        }
        if (this.startYear) {
            this.year = this.startYear
        }
        const date = dayjs().set('month', this.month).set('year', this.year)
        this.emitDateChange(date)
    },
}
